import ImageClass from "@lss/common/src/shell/Image";
import { mc } from "@lss/common/game/characters/MC";
import { extras, images, uiImages } from "@lss/common/game/story/images";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import Game from "../../src/shell/Game";
import { Insta } from "../../src/components/insta/InstaClass";
import UI from "../../src/shell/UI";
import { getInstaData } from "../helpers/InstaPostsHelpers";
import { doPutBlackImage, doSmsSound, doTransition, doWaitImageByTime, isAnnCorrupted, isAnnGF, isAnnHate, isFollowingVanessaLead, isJoeEnemy, randomFloat, updateVariables } from "../helpers/helpers";
import { empty } from "../characters/empty";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import { vanessa } from "../characters/Vanessa";
import { pcLady } from "../characters/PCLady";
import { ann } from "../characters/Ann";
import { jenny } from "../characters/Jenny";
import { emily } from "../characters/Emily";
import { alex } from "../characters/Alex";
import { globals } from "../characters/globals";
import { V8AnnDate, V8AnnWebcam, V8EmilyAlone, V8EmilyAndEx, V8EmilyAndExDoor, V8EmilyAnnMovieNight, V8EmilyKissThoughts, V8JoeMCMorning, V8MorningCallingAnn, V8MorningEmilyKitchen, V8VanessaMCCoffee, V8VanessaMCConv, V8VanessaNaughtySms, V8VanessaMCBeach, V8VanessaMCPark, V8AlexHome, V8AnnAlexHome, V8VanessaJoeMCThreesome, V8JoeCalling, V8VanessaMCNight, V8JennyDate, V8VanessaMCNight_Morning, V8EmilyKitchenNight, V8VanessaMCNightBackFromEmily, V8AnnCorruptionLibrary, V8AnnCorruptionBeforeLibrary, V8AnnChrisHouse, V8AnnChrisTexting, V8AnnCorruptionAlley, V9Start } from "../../src/components/functions";
import { store } from "../../src/store/store";
import { setGlobalQuestions } from "../../src/store/slices/gameObjectSlice";

function shouldSeeAnnWebcamScene() {
    if (isAnnGF() && !ann.properties.isCorrupted && !Game.seenScenarios.includes(`V8AnnWebcamBefore`)) {
        return true;
    }
    return false;

}
export async function setVanessaMCNightVariable() {
    if (Game.seenScenarios.includes(`V8VanessaMCNight`)) {
        await mc.set((properties) => {
            properties.v8VanessaVisitedAtNight = true;
        });
    }
}

export const v8FixParams = async (): Promise<any> => {
    let relationship = 0;
    if (Question.globalAnswers.v7EmilyCarWashThoughtEmilyIsHot) {
        relationship += 3;
    }
    if (Question.globalAnswers.v7EmilyCarWashLookedCloser) {
        relationship += 1;

    }
    if (Question.globalAnswers.v7EmilyShowerPeaked) {
        relationship += 2;
    }

    await mc.set((properties) => {
        properties.emilyRelationship += relationship;
    });

    await setVanessaMCNightVariable();


};
export const V8UnexpectedNTRQuestion = async (showConv = false): Promise<any> => {
    ImageClass.setImage(images.v1.Room1);
    if (showConv) {

        pcLady.talk("Wait!", { method: "Over Chat" });
        mc.talk("What happened?", { method: "On Chat" });
        pcLady.talk("Nothing... There is something I just remembered and forgot to ask you before you started the story...", { method: "Over Chat" });
        mc.talk("Shoot.", { method: "On Chat" });
        pcLady.talk("Remember that you said that you like NTR?", { method: "Over Chat" });
        mc.talk("I do...", { method: "On Chat" });
    }

    pcLady.talk("What about the unexpected?", { method: "Over Chat" });
    mc.talk("What do you mean?", { method: "On Chat" });
    pcLady.talk("Do you like things to be always under your control? Or do you like surprises?", { method: "Over Chat" });
    mc.talk("It really depends on the surprises...", { method: "On Chat" });
    pcLady.talk("Do you always like to make the choice that will lead to consequences, or let things play out?", { method: "Over Chat" });

    mc.talk("Does that mean I'll never have choices to control stuff?", { method: "On Chat" });
    pcLady.talk("No! You still can control stuff... But not everything.", { method: "Over Chat" });
    mc.talk("Mmm...I dunno...Let me think.", { method: "On Chat" });

    await pcLady.setQuestion(new Question({ text: `Do I always like to stay in control regardless...?`, options: { think: true, method: "On Chat" }, key: `V1NtrUnexpected` })
        .option({ title: `Yes`, key: false })
        .option({ title: `No`, key: true }));



};

export const V8Start = async () => {
    // ImageClass.setImage(images.v2_5.BlackScreen);
    // mc.think(`You are about to start playing the recent alpha content (${Game.version})!\nPlease save your game now and load it from this point once the version is completed to avoid bugs and unwanted behavior.`);

    if (!Game.seenScenarios.includes(`v8FixParams`)) {
        await v8FixParams();
        if (Question.globalAnswers.v1EnableNTR && Question.globalAnswers.V1NtrUnexpected === undefined) {
            await V8UnexpectedNTRQuestion(true);
        }
    }
    await globals.set((properties) => {
        properties.playedVersion === "0.8.1b";
    });

    return jump(V8MorningEmilyKitchenBefore, "V8MorningEmilyKitchenBefore");

};

export const V8MorningEmilyKitchenBefore = async (): Promise<any> => {

    doWaitImageByTime(images.v1.Room2, null, 3);
    if (mc.properties.v7WentWithJennyDate) {
        mc.talk(`I got a text...`);
        await Phone.showMessagesUI({ name: jenny.name }, async () => {
            Phone.setMessage({ character: jenny.character, text: `I missed you at the beach today 💋`, options: { wait: false } });
            Phone.setImage({ ...images.v8.JennyBeach_0, character: jenny.character, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `Looking hot 🔥`, options: { wait: randomFloat(1, 2) } });
            await Phone.setMessage({ character: jenny.character, text: `I knew you'd like it!`, options: { wait: randomFloat(1, 2) } });
            Phone.setImage({ ...images.v8.JennyNewBikini_0, character: jenny.character, options: { wait: randomFloat(1, 2) } });
            Phone.setMessage({ character: jenny.character, text: `What do you think of the back? Is it too much?`, options: { wait: randomFloat(1, 2) } });
            Phone.setImage({ ...images.v8.JennyNewBikini_1, character: jenny.character });
            Phone.setMessage({ character: mc.character, text: `No way! It's perfect!`, options: { wait: randomFloat(1, 2) } });
            Phone.setMessage({ character: jenny.character, text: `💋` });
            await Phone.setMessage({ character: mc.character, text: `Any more pics? 😏`, options: { wait: randomFloat(1, 2) } });
            Phone.setMessage({ character: jenny.character, text: `lol! Here's the last one and I gotta get ready for work!`, options: { wait: randomFloat(1, 2) } });
            Phone.setImage({ ...images.v8.JennyNewBikini_2, character: jenny.character, options: { wait: randomFloat(1, 2) } });
            Phone.setMessage({ character: jenny.character, text: `Talk to you later 💋` });
            Phone.setMessage({ character: mc.character, text: `Enjoy the rest of your day 😘` });

            Phone.closeMessagesUI();

        });
        mc.think(`That's it? Nothing else?\nNo one inviting me to go anywhere?`);
    } else {
        mc.think(`Has the world ended?`);
        mc.think(`No phone calls? No texts? No one is at the door?`);
        mc.think(`I can't believe I actually woke up by myself... I forgot what that's like...`);

    }

    mc.think(`So what am I supposed to do now? Just play on the computer and go back to sleep?`);
    mc.think(`I'm feeling a bit hungry...`);
    mc.think(`Well... I guess I'll think on it over breakfast.`);
    return jump(V8MorningEmilyKitchen, "V8MorningEmilyKitchen");
};
export const V8MorningEmilyKitchenAfter = async (): Promise<any> => {
    doTransition(images.v8.V8MCRoomMorningOnPhone_1);
    return jump(V8MCRoomMorning, "V8MCRoomMorning");
};
export const V8MCRoomMorning = async (): Promise<any> => {
    ImageClass.setImage(images.v8.V8MCRoomMorningOnPhone_1);
    const continueTitle = isAnnGF() ? "Call Ann" : "Pass Time";

    await UI.add({
        key: "V8MCRoomMorning",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: continueTitle, key: "callAnn" }
            ]
    });
    if (UI._globalUI.V8MCRoomMorning === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.V8MCRoomMorning === "callAnn") {
        if (isAnnGF()) {

            return jump(V8MorningCallingAnnBefore, "V8MorningCallingAnnBefore");
        } else {
            return jump(V8VanessaMCConvBefore, "V8VanessaMCConvBefore");
        }

    }
    return jump(V8MCRoomMorning, "V8MCRoomMorning");

};

export const V8MorningCallingAnnBefore = async (): Promise<any> => {
    return jump(V8MorningCallingAnn, "V8MorningCallingAnn");
};
export const V8MorningCallingAnnAfter = async (): Promise<any> => {



    doWaitImageByTime(images.v8.V8OutsideMCHouse_0);
    mc.think(`Time to visit Ann...`);
    if (Question.globalAnswers.v3KeepAnsweringChris) {

        return jump(V8VanessaMCConvBefore, "V8VanessaMCConvBefore");
    }
    doSmsSound();
    await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
        Phone.setMessage({ character: vanessa.character, text: `I ordered a package to your address, hold on to it for me until I'll take it, thanksss`, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `Why to my address tho?` });
        Phone.setMessage({ character: vanessa.character, text: `I don't want my parents to see it DUHHH` });
        Phone.setMessage({ character: mc.character, text: `k` });
        Phone.closeMessagesUI();
    });

    return jump(V8AnnDateBefore, "V8AnnDateBefore");

};

export const V8VanessaMCConvBefore = async (): Promise<any> => {
    doSmsSound();
    await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
        if (isAnnGF()) {
            Phone.setMessage({ character: vanessa.character, text: `Come see me on your way to Ann's.`, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `WTF? How did you manage to be up-to-date so fast?` });
            Phone.setMessage({ character: vanessa.character, text: `😈` });
            Phone.setMessage({ character: mc.character, text: `😲` });
            Phone.setMessage({ character: vanessa.character, text: `Just get over here! I have something very interesting I wanna talk to you about 😏` });
            Phone.setMessage({ character: mc.character, text: `Why can't we just talk in texts?` });
            Phone.setMessage({ character: vanessa.character, text: `...` });
            Phone.setMessage({ character: mc.character, text: `Fine. It's on my way anyways.... Be right there.` });

        } else {
            Phone.setMessage({ character: vanessa.character, text: `Come see me`, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `Why?` });
            Phone.setMessage({ character: vanessa.character, text: `JUST CUM 😡` });
            Phone.setMessage({ character: mc.character, text: `I heard that before...` });
            Phone.setMessage({ character: vanessa.character, text: `😡` });

        }
        Phone.closeMessagesUI();
    });

    return jump(V8VanessaMCConv, "V8VanessaMCConv");
};
export const V8VanessaMCConvAfter = async (): Promise<any> => {
    if (isAnnGF()) {
        return jump(V8AnnDateBefore, "V8AnnDateBefore");
    }

    return jump(V8EmilyAnnMovieNightBefore, "V8EmilyAnnMovieNightBefore");
};

export const V8AnnDateBefore = async (): Promise<any> => {
    return jump(V8AnnDate, "V8AnnDate");
};
export const V8AnnDateAfter = async (): Promise<any> => {
    if (ann.properties.isCorrupted) {
        return jump(V8AnnCorruptionBeforeLibraryBefore, "V8AnnCorruptionBeforeLibraryBefore");

    }
    return jump(V8EmilyAnnMovieNightBefore, "V8EmilyAnnMovieNightBefore");
};

export const V8AnnCorruptionBeforeLibraryBefore = async (): Promise<any> => {
    return jump(V8AnnCorruptionBeforeLibrary, "V8AnnCorruptionBeforeLibrary");
};

export const V8AnnCorruptionLibraryBefore = async (): Promise<any> => {
    return jump(V8AnnCorruptionLibrary, "V8AnnCorruptionLibrary");
};

export const V8AnnCorruptionLibraryAfter = async (): Promise<any> => {

    return jump(V8EmilyAnnMovieNightBefore, "V8EmilyAnnMovieNightBefore");
};
export const V8EmilyAnnMovieNightBefore = async (): Promise<any> => {
    if (isAnnHate()) {
        doTransition(images.v8.V8MCRoomMorningOnPhone_1);
        mc.think(`Nothing else to do today...`);
        mc.think(`I'll just pass the time until Emily is ready for our quality time together.`);
        doWaitImageByTime(images.v8.V8RoomNight, {}, 2.5);
        emily.talk(`${mc.name.toLocaleUpperCase()}!!!`);
        mc.think(`Oh. Emily is finally ready.`);
    }
    return jump(V8EmilyAnnMovieNight, "V8EmilyAnnMovieNight");
};
export const V8EmilyAnnMovieNightAfter = async (): Promise<any> => {
    if (mc.properties.gotKissedByEmily) {
        return jump(V8EmilyKissThoughtsBefore, "V8EmilyKissThoughtsBefore");
    }
    return jump(V8EndDay1, "V8EndDay1");
};

export const V8EmilyKissThoughtsBefore = async (): Promise<any> => {


    return jump(V8EmilyKissThoughts, "V8EmilyKissThoughts");
};
export const V8EmilyKissThoughtsAfter = async (): Promise<any> => {
    return jump(V8EndDay1, "V8EndDay1");
};
export const V8VanessaNaughtySmsBefore = async (): Promise<any> => {
    return jump(V8VanessaNaughtySms, "V8VanessaNaughtySms");
};
export const V8VanessaNaughtySmsAfter = async (): Promise<any> => {
    return jump(V8EndDay1, "V8EndDay1");
};
export const V8AnnChrisInvitation = async (): Promise<any> => {

    doSmsSound({ wait: true });
    ImageClass.setImage(images.v8.V8RoomNight);
    await Phone.showMessagesUI({ name: ann.name }, async () => {
        Phone.setMessage({ character: ann.character, text: `😘`, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `Hey sweetie 😘`, options: { wait: false } });
        Phone.setMessage({ character: ann.character, text: `Are you coming? 🙏`, options: { wait: false } });
        await Phone.setQuestion({
            character: ann.character, question: new Question({ text: `So... Are you coming? 🙏`, options: { think: false }, key: `v8AnnChrisWentToHouse` })
                .option({ title: `Sure`, key: true })
                .option({ title: `Nah...`, key: false })
        });

        if (Question.globalAnswers.v8AnnChrisWentToHouse) {
            Phone.setMessage({ character: mc.character, text: `Sure, I'll come.` });
            Phone.setMessage({ character: ann.character, text: `YAY!!! 😘` });
            Phone.setMessage({ character: ann.character, text: `I'll text you the address, see you in a few!` });

        } else {
            Phone.setMessage({ character: mc.character, text: `Nah... I think I'll stay at home.` });
            Phone.setMessage({ character: ann.character, text: `😔` });
            Phone.setMessage({ character: mc.character, text: `Maybe next time... Have fun.` });
            Phone.setMessage({ character: ann.character, text: `Let me know if you change your mind!` });
            Phone.setMessage({ character: mc.character, text: `I will.` });
            Phone.setMessage({ character: ann.character, text: `😘` });

        }

        Phone.closeMessagesUI();
    });

    if (Question.globalAnswers.v8AnnChrisWentToHouse) {
        mc.think(`This is going to be interesting... I've never been with Ann and Chris at the same place since Joey's birthday party.`);
        mc.think(`Their relationship has evolved since then... I hope it's not going to be awkward.`);
        return jump(V8AnnChrisHouseBefore, "V8AnnChrisHouseBefore");


    }
    mc.think(`I'll just let them enjoy their time...`);
    mc.think(`Besides... I already confirmed that their relationship has evolved... I don't want it to be a competition.`);
    mc.think(`I'll sit this one out.`);
    doTransition(images.v5.Room2_2);

    return jump(V8AnnChrisTextingBefore, "V8AnnChrisTextingBefore");
};
export const V8AnnChrisHouseBefore = async (): Promise<any> => {
    return jump(V8AnnChrisHouse, "V8AnnChrisHouse");
};
export const V8AnnChrisTextingBefore = async (): Promise<any> => {
    return jump(V8AnnChrisTexting, "V8AnnChrisTexting");
};
export const V8AnnChrisTextingAfter = async (): Promise<any> => {
    return jump(V8EndDay1, "V8EndDay1");
};
export const V8AnnChrisHouseAfter = async (): Promise<any> => {
    if (Question.globalAnswers.v1EnableNTR) {
        //this condition will always be true because it's ntr scene, but I leave it here in case I wanna use it for a different scene.
        return jump(V8AnnCorruptionAlleyBefore, "V8AnnCorruptionAlleyBefore");
    }
    return jump(V8EndDay1, "V8EndDay1");
};
export const V8AnnCorruptionAlleyBefore = async (): Promise<any> => {
    return jump(V8AnnCorruptionAlley, "V8AnnCorruptionAlley");
};
export const V8AnnCorruptionAlleyAfter = async (): Promise<any> => {
    doTransition(images.v5.Room2_2);
    mc.think(`Wow... What a crazy day...`);
    mc.think(`But now it's time to rest...`);

    return jump(V8EndDay1, "V8EndDay1");
};

export const V8EndDay1 = async (): Promise<any> => {

    if (isAnnCorrupted() && Question.globalAnswers.V8AnnDateMCOkWithChris && !Game.seenScenarios.includes('V8AnnChrisInvitation')) {
        return jump(V8AnnChrisInvitation, "V8AnnChrisInvitation");
    }

    if (!isFollowingVanessaLead() && !Game.seenScenarios.includes('V8VanessaNaughtySmsBefore')) {
        doTransition(images.v5.Room2_2);
        return jump(V8VanessaNaughtySmsBefore, "V8VanessaNaughtySmsBefore");
    } else {
        ImageClass.setImage(images.v5.Room2_2);

    }


    await UI.add({
        key: "V8EndDay1",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Go to sleep", key: "continue" }
            ]
    });
    if (UI._globalUI.V8EndDay1 === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.V8EndDay1 === "continue") {
        return jump(V8Day2, "V8Day2");

    }

    return jump(V8EndDay1, "V8EndDay1");
};

export const V8Day2 = async (): Promise<any> => {
    doWaitImageByTime(images.v1.Room2, { duration: 2, wait: 2 });
    mc.think(`Hmmm... a text from Ann.`);
    // TODO: Add Ann's phone images (normal and corrupted )
    if (mc.properties.annStatus === "gf") {
        if (!ann.properties.isCorrupted) {
            mc.think(`Wow, she sent it real early... I wonder why she was awake.`);
            await Phone.showMessagesUI({ name: ann.name }, async () => {
                Phone.setMessage({
                    character: ann.character, text: `${mc.name}! I didn't want to call since it's so early but something came up... 
I got a call telling me to come over for the college testing right now instead of tomorrow...
I know we planned to do a special night together today and I'm so sorry!
I will be available tonight so we can talk...
I hope you aren't mad... 😘`, options: { wait: false }
                });
                let message = `Oh! Almost forgot. Alex's laptop is giving her a hard time again... If you could help her out I'd really appreciate it!`;
                if (Question.globalAnswers.V8AnnDateTargetsResults === "tryToHit") {
                    message += `\nIf you do... Can you bring her the teddy you won for me? She wants to take some pictures with it or something... lol 😘`;
                } else {
                    message += `😘`;
                }
                Phone.setMessage({
                    character: ann.character, text: message

                });
                await Phone.closeMessagesUI();
            });
            mc.think(`That's unexpected...`);
            mc.think(`I was actually excited for our date tonight... Just my luck...`);
            if (Question.globalAnswers.V8AnnDateTargetsResults === "tryToHit") {
                ImageClass.setImage(images.v8.V8MCRoomMorningTeddy);
                // mc.think(`I guess this thing is going to stay here for a bit longer...`); 

            } else {

            }
        } else {
            await Phone.showMessagesUI({ name: ann.name }, async () => {
                let message = `Good morning! 😘😘
Alex's laptop is giving her a hard time again... Can you see if you can help her out?? I'd really appreciate it! 😏`;
                if (Question.globalAnswers.V8AnnDateTargetsResults === "tryToHit") {
                    message += `\nIf you do... Can you bring her the teddy you won for me? She wants to take some pictures with it or something... lol 😘`;
                }
                Phone.setMessage({
                    character: ann.character, text: message, options: { wait: false }

                });
                if (Question.globalAnswers.v8AnnChrisWentToHouse === false) {
                    if (Question.globalAnswers.V1NtrUnexpected) {
                        Phone.setMessage({ character: ann.character, text: `Oh and btw I found a couple more photos that I forgot to send you yesterday!`, options: { wait: false } });
                        Phone.setImage({ ...images.v8.V8AnnChrisPics_3, character: ann.character, options: { wait: false } });
                        Phone.setImage({ ...images.v8.V8AnnChrisPics_5, character: ann.character, options: { wait: false } });
                    } else {
                        await Phone.setMessage({ character: mc.character, text: `For a second I was sure you're gonna send more photos of you and Chris from yesterday.` });
                        Phone.setMessage({ character: ann.character, text: `I have a couple more I haven't sent you 😜`, options: { wait: 0.1 } });
                        await Phone.setQuestion({
                            character: ann.character, question: new Question({ text: `I have a couple more I haven't sent you 😜`, options: { think: false }, key: `v8AnnChrisMorningSendMorePics` })
                                .option({ title: `Send it`, key: true })
                                .option({ title: `I'll pass`, key: false })
                        });
                        if (Question.globalAnswers.v8AnnChrisMorningSendMorePics) {
                            Phone.setMessage({ character: mc.character, text: `Send it` });
                            await Phone.setMessage({ character: ann.character, text: `sending!`, options: { wait: randomFloat(0.5, 1) } });
                            Phone.setImage({ ...images.v8.V8AnnChrisPics_3, character: ann.character, options: { wait: randomFloat(0.5, 1) } });
                            Phone.setImage({ ...images.v8.V8AnnChrisPics_5, character: ann.character, options: { wait: randomFloat(0.5, 1) } });
                            Phone.setMessage({ character: ann.character, text: `I only now realize how crazy that night was when looking at those pictures again!` });
                            Phone.setMessage({ character: ann.character, text: `anyway! Gotta go talk to you later 😘` });
                        } else {
                            Phone.setMessage({ character: mc.character, text: `I'll pass` });
                            Phone.setMessage({ character: ann.character, text: `ok 😘` });

                        }
                    }

                }
                await Phone.closeMessagesUI();
            });

            if (Question.globalAnswers.v8AnnChrisWentToHouse === false && (Question.globalAnswers.v8AnnChrisMorningSendMorePics || Question.globalAnswers.V1NtrUnexpected)) {
                mc.think(`Getting those pictures from Ann the morning after proves to me that it wasn't just a one time thing during a crazy night...`);
                mc.think(`Anyway...`);
            }
        }

    } else {
        // TODO: nude profile pic
        await Phone.showMessagesUI({ name: ann.name }, async () => {
            Phone.setMessage({
                character: ann.character, text: `Hey ${mc.name}...
Is it possible that you could take a look at Alex's laptop...? It's giving her trouble again...
I can understand if you don't have time... But it would be great if you could! Thanks!`, options: { wait: false }
            });

            await Phone.closeMessagesUI();
        });
    }

    mc.think(`I guess I'm going to pay a visit to Alex later.`);

    if (mc.properties.joeStatus !== "enemy") {
        return jump(V8JoeMCMorningBefore, "V8JoeMCMorningBefore");
    } else {

    }
    // TODO: continue Joe rival
    return Game.showEnding("alpha");
};

export const V8JoeMCMorningBefore = async (): Promise<any> => {
    ImageClass.setImage(images.v1.Room2, { duration: 2 });
    mc.think(`What is that noise coming from the living room...?`);
    if (mc.properties.gotKissedByEmily) {
        mc.think(`It must be Emily... I better try to act normally and not avoid her.`);
    } else {
        mc.think(`It must be Emily, I'll go say good morning.`);

    }
    return jump(V8JoeMCMorning, "V8JoeMCMorning");
};
export const V8JoeMCMorningAfter = async (): Promise<any> => {
    return jump(V8Day2_Events, "V8Day2_Events");

};

export const V8Day2_Events = async (): Promise<any> => {
    if (!Game.seenScenarios.includes(`V8Day2_Events`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 135;
            properties.instaFollowers = 1075372;
        });
    }

    if (!Game.seenScenarios.includes(`V8EmilyAndExDoorBefore`) && Question.globalAnswers.v7InvitedEmilysEx === "invited") {
        return jump(V8EmilyAndExDoorBefore, "V8EmilyAndExDoorBefore");
    }

    if (!Game.seenScenarios.includes(`V8AlexHomeBefore`)) {
        mc.think(`Now's the perfect opportunity to see what happened to Alex's laptop.`);
        mc.think(`Again...`);

        return jump(V8AlexHomeBefore, "V8AlexHomeBefore");
    }

    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa" && !Game.seenScenarios.includes(`V8VanessaMCCoffeeBefore`)) {
        if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants) {
            // TODO: giving the customer what he wants.


        } else {
            ImageClass.setImage(images.v8.V8AlexFrontDoor_0);
            return jump(V8VanessaMCCoffeeBefore, "V8VanessaMCCoffeeBefore");
        }

    }

    if (!Game.seenScenarios.includes(`V8VanessaMCParkBefore`)) {
        doSmsSound();
        await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
            Phone.setMessage({ character: vanessa.character, text: `Meet me at the local park.`, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `Why? What's going on?` });
            Phone.setMessage({ character: vanessa.character, text: `Just come, I'm waiting.` });
            Phone.closeMessagesUI();
        });
        mc.think(`Better go and see what she wants...`);
        return jump(V8VanessaMCParkBefore, "V8VanessaMCParkBefore");
    }



    // If watched the webcam scene, jump to Emily's scene
    if (Game.seenScenarios.includes(`V8AnnWebcamBefore`)) {
        if (Question.globalAnswers.v7InvitedEmilysEx === "invited") {
            return jump(V8EmilyAndExBefore, "V8EmilyAndExBefore");
        }
        return jump(V8EmilyAloneBefore, "V8EmilyAloneBefore");
    }
    // TODO: add condition for Joe rival
    if (Game.seenScenarios.includes(`V8JoeCallingBefore`)) {
        if (!Game.seenScenarios.includes(`V8EmilyAndExBefore`) && !Game.seenScenarios.includes(`V8EmilyAloneBefore`)
            && !shouldSeeAnnWebcamScene()
        ) {
            if (Question.globalAnswers.v7InvitedEmilysEx === "invited") {
                return jump(V8EmilyAndExBefore, "V8EmilyAndExBefore");
            }
            return jump(V8EmilyAloneBefore, "V8EmilyAloneBefore");
        }
    }

    ImageClass.setImage(images.v8.V8RoomNight);
    await UI.add({
        key: "V8BeforeNightEvents",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Continue", key: "continue" }
            ]
    });
    if (UI._globalUI.V8BeforeNightEvents === "insta") {
        await Insta.open(getInstaData());
        return jump(V8Day2_Events, "V8Day2_Events");
    }

    if (UI._globalUI.V8BeforeNightEvents === "continue") {

        // This leads to the underpass threesome
        // if (Question.globalAnswers.v7JoeGymToldBreakupVanessa === false) {
        if (!Game.seenScenarios.includes(`V8JoeCallingBefore`) && mc.properties.joeStatus !== "enemy") {

            return jump(V8JoeCallingBefore, "V8JoeCallingBefore");

            // if (Question.globalAnswers.v7JoeGymToldBreakupVanessa === false) {
            //     return jump(V8JoeCallingBefore, "V8JoeCallingBefore");
            // } else {
            //     // TODO: alpha remove after alpha
            //     await empty.setQuestion(new Question({ text: `*ALPHA NOTE* - Your choice that Vanessa and Joe should breakup will cause you missing a big scene in this alpha.\nWould you like to change your choice to see the content?`, options: { think: true }, key: `v7JoeGymToldBreakupVanessa` })
            //         .option({ title: `Stay together (see content)`, key: true })
            //         .option({ title: `Break-up (skip content)`, key: false }));
            //     if (Question.globalAnswers.v7JoeGymToldBreakupVanessa) {
            //         await mc.set((properties) => {
            //             updateVariables('v8JoeMorningAgreeThreesomeWithVanessa', true);
            //         });
            //         return jump(V8JoeCallingBefore, "V8JoeCallingBefore");
            //     } else {
            //         if (mc.properties.hasJennysNumber) {
            //             return jump(V8JennyDateBefore, "V8JennyDateBefore");
            //         }
            //     }
            // }

            // }
        }
        // Ann's path
        if (mc.properties.annStatus === "gf") {
            if (ann.properties.isCorrupted) {
                // TODO: Ann's corruption scene + hate
                // ImageClass.setImage(images.v2_5.BlackScreen);
                empty.think(`*PLACEHOLDER* - Missing scene for Ann's corruption that will be added later.`);

            } else {
                return jump(V8AnnWebcamBefore, "V8AnnWebcamBefore");
            }



        } else {
            // Ann hate
            ImageClass.setImage(images.v2_5.BlackScreen);
            empty.think(`*PLACEHOLDER* - Missing scene that will be added later.`);
        }

        // if didn't go to the threesome
        // TODO: change to always trigger, not to be depended on v7VanessaConvAgreeSheIsPerfect
        if (!Game.seenScenarios.includes(`V8VanessaJoeMCThreesome`) && Question.globalAnswers.v1WentToTheBarWith === "vanessa" && !isFollowingVanessaLead()) {
            return jump(V8VanessaMCNightBefore, "V8VanessaMCNightBefore");
        }

    }
    return jump(V8Day2EndDay2, "V8Day2EndDay2");





};
export const V8AlexHomeBefore = async (): Promise<any> => {
    return jump(V8AlexHome, "V8AlexHome");
};
export const V8AlexHomeAfter = async (): Promise<any> => {
    doTransition(images.v8.V8AlexFrontDoor_0);
    mc.think(`Wow... I didn't expect that at all.`);
    mc.think(`Who knew she felt like that...`);

    return jump(V8Day2_Events, "V8Day2_Events");
};
export const V8VanessaMCCoffeeBefore = async (): Promise<any> => {
    await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
        Phone.setMessage({ character: vanessa.character, text: `Meet me at the coffee shop. NOW!`, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `Why? What happened?` });
        Phone.setMessage({ character: vanessa.character, text: `The grandpa is here, and he is not alone!\nThis could be our chance to get something on him!` });
        Phone.setMessage({ character: mc.character, text: `Oh wow! On my way!` });
        // Phone.setImage({ ...images., character: .character, options: { wait: false } });
        // Phone.talk({ character: .character, text: `` });

        Phone.closeMessagesUI();
    });
    return jump(V8VanessaMCCoffee, "V8VanessaMCCoffee");
};
export const V8VanessaMCCoffeeAfter = async (): Promise<any> => {
    return jump(V8VanessaMCBeachBefore, "V8VanessaMCBeachBefore");
};
export const V8VanessaMCBeachBefore = async (): Promise<any> => {
    return jump(V8VanessaMCBeach, "V8VanessaMCBeach");
};
export const V8VanessaMCBeachAfter = async (): Promise<any> => {
    return jump(V8VanessaMCParkBefore, "V8VanessaMCParkBefore");
};
export const V8VanessaMCParkBefore = async (): Promise<any> => {
    return jump(V8VanessaMCPark, "V8VanessaMCPark");
};
export const V8VanessaMCParkAfter = async (): Promise<any> => {
    return jump(V8AnnAlexHomeBefore, "V8AnnAlexHomeBefore");
};
export const V8AnnAlexHomeBefore = async (): Promise<any> => {
    return jump(V8AnnAlexHome, "V8AnnAlexHome");
};
export const V8AnnAlexHomeAfter = async (): Promise<any> => {
    return jump(V8Day2_Events, "V8Day2_Events");

};
export const V8JoeCallingBefore = async (): Promise<any> => {
    doSmsSound();
    ImageClass.setImage(images.v8.V8RoomNightOnPhone);

    return jump(V8JoeCalling, "V8JoeCalling");
};
export const V8JoeCallingAfter = async (): Promise<any> => {
    if (mc.properties.hasJennysNumber) {
        return jump(V8JennyDateBefore, "V8JennyDateBefore");
    }

    if (Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessa || Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessaPhone) {
        return jump(V8VanessaJoeMCThreesomeBefore, "V8VanessaJoeMCThreesomeBefore");
    }
    return jump(V8Day2_Events, "V8Day2_Events");
};
export const V8VanessaJoeMCThreesomeBefore = async (): Promise<any> => {
    return jump(V8VanessaJoeMCThreesome, "V8VanessaJoeMCThreesome");
};
export const V8VanessaJoeMCThreesomeAfter = async (): Promise<any> => {
    return jump(V8Day2_Events, "V8Day2_Events");

};

export const V8EmilyAndExDoorBefore = async (): Promise<any> => {
    return jump(V8EmilyAndExDoor, "V8EmilyAndExDoor");
};
export const V8EmilyAndExDoorAfter = async (): Promise<any> => {
    return jump(V8Day2_Events, "V8Day2_Events");
};

export const V8AnnWebcamBefore = async (): Promise<any> => {
    // TODO: if did a threesome, say something about that before opening the call
    return jump(V8AnnWebcam, "V8AnnWebcam");
};
export const V8AnnWebcamAfter = async (): Promise<any> => {
    return jump(V8Day2_Events, "V8Day2_Events");
};

export const V8EmilyAndExBefore = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V8AnnWebcam`)) {
        doWaitImageByTime({ ...images.v8.V8MCRoomAnnWebcam_0, partialsToDisplay: [images.v8.V8MCRoomAnnWebcam_0.partials.V8MCRoomAnnWebcam_0_p_1] });
    } else {
    }
    emily.talk(`Ahh!!`, { method: "Shouting" });
    mc.think(`Emily's home...`);
    return jump(V8EmilyAndEx, "V8EmilyAndEx");
};
export const V8EmilyAndExAfter = async (): Promise<any> => {
    return jump(V8Day2EndDay2, "V8Day2EndDay2");
};
export const V8EmilyAloneBefore = async (): Promise<any> => {
    return jump(V8EmilyAlone, "V8EmilyAlone");
};
export const V8EmilyAloneAfter = async (): Promise<any> => {
    return jump(V8Day2EndDay2, "V8Day2EndDay2");
};

export const V8VanessaMCNightBefore = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V8EmilyKitchenNight`)) {
        return jump(V8VanessaMCNightBackFromEmily, "V8VanessaMCNightBackFromEmily");
    }
    return jump(V8VanessaMCNight, "V8VanessaMCNight");
};
export const V8VanessaMCNightAfter = async (): Promise<any> => {
    return jump(V8Day2EndDay2, "V8Day2EndDay2");
};
export const V8EmilyKitchenNightBefore = async (): Promise<any> => {
    mc.think(`Fuck. I'm thirsty.`);
    mc.think(`Why couldn't I think of that before entering bed...`);
    mc.think(`I won't be able to fell asleep now.`);
    mc.think(`Better grab a glass of water.`);
    return jump(V8EmilyKitchenNight, "V8EmilyKitchenNight");
};
export const V8EmilyKitchenNightAfter = async (): Promise<any> => {
    if (Game.seenScenarios.includes('V8VanessaMCNight')) {
        return jump(V8VanessaMCNightBefore, "V8VanessaMCNightBefore");
    }
    return jump(V8Day2EndDay2, "V8Day2EndDay2");
};


export const V8JennyDateBefore = async (): Promise<any> => {
    return jump(V8JennyDate, "V8JennyDate");
};
export const V8JennyDateAfter = async (): Promise<any> => {
    if (Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessa || Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessaPhone) {
        return jump(V8VanessaJoeMCThreesomeBefore, "V8VanessaJoeMCThreesomeBefore");
    }
    return jump(V8Day2_Events, "V8Day2_Events");
};


export const V8Day2EndDay2 = async (): Promise<any> => {
    let flag = true;
    if (Game.seenScenarios.includes(`V8VanessaMCNightBefore`)) {
        flag = false;
    }


    if (Game.seenScenarios.includes(`V8Day2EndDay2`)) {
        if (flag) {

            ImageClass.setImage(images.v5.Room2_2);
        }
    } else {
        if (flag) {
            doTransition(images.v5.Room2_2);
        }

        await alex.set((properties) => {
            properties.instaFollowing = 175;
            properties.instaFollowers = Math.floor(properties.instaFollowers * 1.25);
        });
        if (ann.properties.isCorrupted || mc.properties.annStatus === "hate") {
            // TODO:
            // await ann.set((properties) => {
            //     properties.instaFollowing = 300;
            //     properties.instaFollowers = 5581;
            // });
        }
    }

    if (!Game.seenScenarios.includes(`V8VanessaMCNightBefore`) && !Game.seenScenarios.includes(`V8VanessaJoeMCThreesome`) && !isFollowingVanessaLead()) {
        return jump(V8VanessaMCNightBefore, "V8VanessaMCNightBefore");


    }
    if (!Game.seenScenarios.includes(`V8EmilyKitchenNightBefore`)) {
        return jump(V8EmilyKitchenNightBefore, "V8EmilyKitchenNightBefore");


    }
    if (!ann.properties.hasInsta) {

        await ann.set((properties) => {
            properties.hasInsta = true;
        });
    }

    await UI.add({
        key: "v8EndDay2",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "End day", key: "continue" }
            ]
    });
    if (UI._globalUI.v8EndDay2 === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v8EndDay2 === "continue") {
        if (isJoeEnemy() || isAnnHate()) {
            return Game.showEnding("normal");
        }
        return jump(V9Start, "V9Start");

    }
    return jump(V8Day2EndDay2, "V8Day2EndDay2");

};
